import { Stack, type SxProps, type Theme } from '@mui/material';
import type { ReactNode } from 'react';

import { EmptyStateContent } from './emptyStateContent';

export const PanelEmptyState = ({
  title,
  description,
  icon,
  primaryAction,
  secondaryAction,
  minHeight = '160px',
  sx,
}: {
  title?: ReactNode;
  description?: ReactNode;
  icon?: string | ReactNode;
  primaryAction?: ReactNode;
  secondaryAction?: ReactNode;
  minHeight?: string;
  sx?: SxProps<Theme>;
}) => {
  return (
    <Stack
      sx={[
        {
          alignItems: 'center',
          justifyContent: 'center',
          minHeight,
          padding: '24px',
        },
        ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
      ]}
    >
      <EmptyStateContent
        title={title}
        description={description}
        icon={icon}
        primaryAction={primaryAction}
        secondaryAction={secondaryAction}
        titleVariant='h4'
        descriptionVariant='body2'
        gap='12px'
        textGap='8px'
        maxWidth='440px'
      />
    </Stack>
  );
};
